/** Global, engine-wide constants. Kept free of any domain logic. */

/** Simulation runs at a fixed rate. All gameplay time is measured in ticks. */
export const TICKS_PER_SECOND = 20;
export const MS_PER_TICK = 1000 / TICKS_PER_SECOND;

/** Rendering target (informational — the browser drives actual rAF cadence). */
export const TARGET_FPS = 60;

/**
 * Isometric tile footprint in screen pixels at zoom = 1. Classic 2:1 ratio.
 * A tile diamond is TILE_WIDTH wide and TILE_HEIGHT tall.
 */
export const TILE_WIDTH = 64;
export const TILE_HEIGHT = 32;
export const TILE_HALF_WIDTH = TILE_WIDTH / 2;
export const TILE_HALF_HEIGHT = TILE_HEIGHT / 2;

/** Vertical screen offset applied per unit of tile elevation. */
export const ELEVATION_STEP = 8;

/** A chunk is CHUNK_SIZE × CHUNK_SIZE tiles — the unit of culling & streaming. */
export const CHUNK_SIZE = 16;
